// extracted by mini-css-extract-plugin
module.exports = {"label":"Label__label--363QH","disabled":"Label__disabled--3QYWd","expanded":"Label__expanded--3TvwI"};